/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const ROUTES = {
  home: {
    root: '/', // use in email template
    home: '/home',
    menu: '/home/:menu',
    signUp: '/create',
    logIn: '/login', // use in email template
    forgotPassword: '/forgot',
    confirmEmail: {
      root: '/confirm',
      alreadyActivated: '/confirm/already-activated',
    },
    confirmChangeEmail: '/new-email/confirm',
    changePassword: {
      root: '/reset',
      new: '/reset/new',
    },
    contactUs: '/contact-us', // use in email template
    leaveEmail: '/leave-email',
    noAvailablePrinter: '/no-available-printer',
  },

  auth: {
    login: '/auth/login',
    passwordExpired: '/auth/password-expired',
    loginMaxAttempted: '/auth/login-attempted',
    resendConfirmEmail: '/auth/resend-confirm-email',
  },

  profile: {
    root: '/',
    create: '/profile/create',
    resend: '/profile/resend',
    view: '/profile/view',
    changePlan: {
      root: '/profile/plan-choice',
      terms: '/profile/plan-choice/terms',
      newPlanAccepted: '/profile/plan-choice/new-plan-accepted',
      noAvailablePrinter: '/profile/plan-choice/no-available-printer',
    },
    renewPlan: {
      root: '/profile/plan-renew',
      terms: '/profile/plan-renew/terms',
      accepted: '/profile/plan-renew/accepted',
    },
    enrollPlan: {
      root: '/profile/plan-enroll',
      terms: '/profile/plan-enroll/terms',
      accepted: '/profile/plan-enroll/accepted',
      noAvailablePrinter: '/profile/plan-enroll/no-available-printer',
    },
    renewAndChangePlan: {
      accepted: '/profile/plan-renew-and-change/accepted',
    },
    settings: '/profile/settings',
  },
}
